class FilterSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.clearButton = this.querySelector("[data-search-clear]");
    this.clearButton.addEventListener("click", this.clear.bind(this));
    this.filterEl = this.closest("[data-filter-el]");
    this.input.addEventListener("keyup", this.onInput.bind(this));
  }
  clear() {
    this.input.value = "";
    this.onInput();
  }
  onInput() {
    console.log('onInput', this.input.value);
    if (this.input.value.length > 0) {
      this.clearButton.classList.remove("visually-hidden");
    } else {
      this.clearButton.classList.add("visually-hidden");
    }
    this.filterEl.querySelectorAll("[data-filter-option]").forEach(option => { 
      const text = option.querySelector("[data-filter-text]").textContent;
      if (this.input.value.length == 0 || text.toLowerCase().includes(this.input.value.toLowerCase())) {
        console.log('to show', option);
        option.classList.remove("visually-hidden");
      } else {
        console.log('to hide', option);
        option.classList.add("visually-hidden");
      }
    });
  }
}
customElements.define("filter-search", FilterSearch);

class FilterClear extends HTMLElement {
  constructor() {
    super();
    this.clearLink = this.querySelector("[data-filter-clear]");
    this.clearLink.addEventListener("click", this.clear.bind(this));
    this.form = this.closest("form");
    this.filterEl = this.closest("[data-filter-el]");
    this.filterContainer = this.closest('[data-filter-container]');
    document.addEventListener('filter:updated', this.handleFilterUpdate.bind(this));
    this.handleFilterUpdate();
  }
  clear(e) {
    e.preventDefault();
    this.filterEl.querySelectorAll("input").forEach(input => {
      input.checked = false;
    });
    this.form.dispatchEvent(new Event('input', { bubbles: true }));
  }
  handleFilterUpdate() {
    let hasChecked = false;
    this.filterEl.querySelectorAll("input").forEach(input => {
      if (input.checked) {
        hasChecked = true;
      }
    }); 
    if (!hasChecked) {
      this.classList.add("visually-hidden");
    } else {
      this.classList.remove("visually-hidden");
    }
    if (this.filterEl.hasAttribute('open')) {
      this.filterContainer.style.maxHeight = this.filterContainer.scrollHeight + 'px';
    }
  }
}
customElements.define("filter-clear", FilterClear);


class FilterSortManager {
  constructor() {
    this.container = document.querySelector('.collection-layout__filters .filter-sort-container');
    if (!this.container) return;
    
    this.originalParent = this.container.parentElement;
    this.desktopTarget = document.querySelector('#main-collection-filters-sort');
    this.handleResize = this.handleResize.bind(this);
    
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Initial check
  }

  handleResize() {
    if (window.innerWidth < 990) {
      if (this.container.parentElement !== this.originalParent) {
        this.originalParent.appendChild(this.container);
      }
    } else {
      if (this.container.parentElement !== this.desktopTarget) {
        this.desktopTarget.appendChild(this.container);
      }
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new FilterSortManager();


  const dataSubDetails = document.querySelectorAll("[data-sub-details]");
  dataSubDetails.forEach(subDetails => {
    const dataSubSummary = subDetails.querySelector("[data-sub-summary]");
    dataSubSummary.addEventListener("click", function(e) {
      if (window.innerWidth < 890) {
        e.preventDefault();
        subDetails.open = false;
        const container = subDetails.closest(".filter-drawer__main");
        container.classList.add('visibility-hidden');
        subDetails.classList.toggle("open");
        const isOpen = subDetails.classList.contains("open");
        console.log(isOpen);
        dataSubDetails.forEach(anotherSubDetails => {
          anotherSubDetails.classList.remove("mobile-hidden");
          if (isOpen == true && anotherSubDetails !== subDetails) {
            anotherSubDetails.classList.add("mobile-hidden");
          }
        });
        if (subDetails.classList.contains("open")) {
          subDetails.open = true;
        }
        container.classList.remove('visibility-hidden');
      }
    });
  });
  document.querySelector(".filter-drawer__open")?.addEventListener('click', function() {
    dataSubDetails.forEach(subDetails => {
      subDetails.classList.remove('mobile-hidden');
      subDetails.classList.remove('open');
    });
  });


  // search page bugfix
  document.querySelector(".template-search .search__input")?.addEventListener('focus', function(e) {
    if (window.innerWidth < 890) {
      document.querySelector(".collection-layout__filters")?.classList.add("visibility-hidden");
      window.scrollTo({
        top: window.scrollY,
        behavior: 'instant'
      });
    }
  });
  document.querySelector(".template-search .search__input")?.addEventListener('blur', function(e) {
    document.querySelector(".collection-layout__filters")?.classList.remove("visibility-hidden");
  });
});
